import { useState } from "react";

const initialsOf = (name) =>
  (name || "M").trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join("").toUpperCase();

// Google profile photo with a graceful initials fallback (used in nav + dashboard).
export const UserAvatar = ({ picture, name, size = 56, className = "", testId = "user-avatar" }) => {
  const [err, setErr] = useState(false);
  const ring = "rounded-full border border-[#F59E0B]/40 shrink-0";
  if (picture && !err) {
    return (
      <img
        src={picture}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setErr(true)}
        style={{ width: size, height: size }}
        className={`${ring} object-cover ${className}`}
        data-testid={`${testId}-img`}
      />
    );
  }
  return (
    <div
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      className={`${ring} bg-[#F59E0B]/10 flex items-center justify-center font-display text-[#B45309] ${className}`}
      data-testid={`${testId}-initials`}
    >
      {initialsOf(name)}
    </div>
  );
};
